var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"checkbox"}}),_vm._v("\n  "+_vm._s(_vm.number)+" "+_vm._s(_vm.option.label)+"\n  "),_vm._l((_vm.option.images),function(image,key){return _c('Img',{key:key,attrs:{"url":image.url,"data":image.data}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }